import {authHeader, ApiConfigs} from "../_helpers";
import { authService } from "./auth.service";

export const attributeValuesService = {
    getAll,
    show,
    create,
    delete: _delete,
    update
};

function getAll(id:string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.attributeValues.getAll.replace(':id', id)
    .replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function show(id: string, attribute:string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.attributeValues.show.replace(':id', id).replace(':attribute', attribute)}`, requestOptions)
        .then(
            handleResponse
        );
}

function create(id:string,payload:object ){
    const requestOptions = {
        method: "POST",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.attributeValues.create.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function _delete(id: string, attribute:string){
    const requestOptions={
        method:"DELETE",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json", "Accept": "application/json" },

    }

    return fetch(`${ApiConfigs.base_url+ApiConfigs.attributeValues.delete.replace(':id', id).replace(':attribute', attribute)}`, requestOptions)
        .then(handleResponse);
}

function update(id: string, payload: object, attribute:string){
    console.log('ertert', id)
    const requestOptions={
        method:"PUT",
        credentials : 'include' as RequestCredentials,
        headers: { ...authHeader(), "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
    }

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.attributeValues.update.replace(':id', id).replace(':attribute', attribute)}`, requestOptions)
    .then(handleResponse);
}


function handleResponse(response: Response) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api

                localStorage.removeItem('user');
                localStorage.removeItem("store");

                location.reload();
                authService.logout();
            }
            const error = (data && data.message) || response.status || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}